import worship from '~/assets/Focus on Worship.svg'
import giving from '~/assets/Automate Your Giving.svg'
import rewards from "~/assets/Maximise Rewards.svg"
import styles from './index.module.scss'
import { Page } from '@lib/components'
import { MytennightsTestId } from '@lib/testing'
import SandLight from '~/assets/Sand Light.png'
import SandDark from '~/assets/Sand Dark.png'
import mfLogo from '~/assets/MF logo Dark.svg'
import mtnLogo from '~/assets/MTN logo dark.svg'
import irLogo from "~/assets/IR.svg"
import muslimAid from '~/assets/Muslim Aid.svg'
import orphansInNeed from '~/assets/Orphans in need.tif.svg'
import charityWater from '~/assets/Water Charity.svg'
import { scrollToHash, ScrollHash } from "@shamaazi/mytennights"

export const Explainer = () => {
  const logos = [orphansInNeed, muslimAid, irLogo, charityWater]

  return <Page className="bg-white text-center items-center ">
    <div className=''>
      <div style={{ backgroundImage: `url(${SandDark})` }}
        className="bg-no-repeat bg-cover bg-center text-mtd-secondary-5 p-5 text-center flex flex-col items-center justify-center">
        <p className='text-mtd-label text-mtd-gray-6 font-normal'>Helping the Ummah</p>
        <div className="flex items-center justify-center overflow-x-auto gap-16 mt-4">
          {logos.map((logo, index) => (
            <img key={index} src={logo} alt="Charity Logo" />
          ))}
        </div>
      </div>
      <div style={{ backgroundImage: `url(${SandLight})` }}
        className="bg-no-repeat bg-cover bg-center text-mtd-secondary-5 px-6 py-16 text-center flex flex-col items-center justify-center">
        <div className="flex flex-col md:flex-row md:items-baseline justify-center md:gap-10">
          <div>
            <p className="text-mtd-h1 font-bold">Over 200k</p>
            <p className="text-mtd-h3 font-semibold">Donors</p>
          </div>
          <div>
            <p className="text-mtd-h1 font-bold">&</p>
          </div>
          <div>
            <p className="text-mtd-h1 font-bold ">Over £ 100M</p>
            <p className="text-mtd-h3 font-semibold">Raised through</p>
          </div>
        </div>
        <p className="mt-10 text-mtd-h3 font-medium">The team that brought you</p>

        <div className="flex flex-col md:flex-row items-center justify-center gap-5 md:gap-12 mt-4">
          <img src={mtnLogo} alt="MYTENNIGHTS" className="h-4" />
          <img src={mfLogo} alt="MYFRIDAYS" className="h-5" />
        </div>
      </div>
      <div className="my-10 text-mtd-secondary-5 w-full max-w-mtd-page mx-auto text-center">
        <h2 className="text-mtd-h5 font-bold">Why MyTenDays</h2>
        <p className="text-mtd-input font-normal">Never Miss The 10 Days of Dhul Hijjah</p>

        <div className="row flex flex-wrap justify-around mt-7">
          <div className={`flex flex-col items-center justify-center ${styles.item}`}>
            <img src={worship} alt="worship" />
            <h3 className="text-mtd-h3 font-bold pt-8">Focus on Worship</h3>
            <p className="text-mtd-body font-normal pt-1">
              Dedicate more time to prayer, fasting, and maximise your spiritual rewards.
            </p>
          </div>
          <div className={`flex flex-col mt-7 md:mt-0 items-center justify-center ${styles.item}`}>
            <img src={rewards} alt="rewards" />
            <h3 className="text-mtd-h3 font-bold pt-8">Maximise Rewards</h3>
            <p className="text-mtd-body font-normal pt-1">
              Give consistently and multiply your blessings in the 10 days Dhul Hijjah.
            </p>
          </div>
          <div className={`flex flex-col mt-7 md:mt-0 items-center justify-center ${styles.item}`}>
            <img src={giving} alt="giving" />
            <h3 className="text-mtd-h3 font-bold pt-8">Automate Your Giving</h3>
            <p className="text-mtd-body font-normal pt-1">
              And never miss out on giving during the blessed 10 days of Dhul Hijjah.
            </p>
          </div>
        </div>
      </div>

      <div style={{ backgroundImage: `url(${SandLight})` }} className='bg-no-repeat bg-cover px-10 py-16 text-center flex flex-col items-center justify-center'>
        <p className='text-mtd-h5 text-center text-mtd-secondary-5 font-bold leading-9'>Never Miss The 10 Days of</p>
        <p className='text-mtd-h5 text-center text-mtd-secondary-5 font-bold leading-9'>Dhul Hijjah</p>
        <p className='text-mtd-input text-mtd-secondary-5 mt-3'>Automate your donations this Dhul Hijjah.</p>
        <button
          data-test-id={MytennightsTestId.donateNowButton}
          onClick={() => {
            scrollToHash(ScrollHash.mtdDonateNow)
          }}
          className={`flex flex-row justify-center mx-1 text-base w-56 h-12 items-center
                           rounded-full bg-mtd-yellow-100 font-medium sm:font-semibold mt-10 py-2 text-white`}>SET UP DONATION
        </button>
      </div>
    </div>
  </Page>
}